import styled from "styled-components";
import { Grid2 } from "@mui/material";
import BaseTable from "../../components/Table";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
`;

export const Section = styled(Grid2)`
  position: relative;
`;

export const Options = styled.div`
  display: flex;
  gap: 16px;
`;

export const Table = styled(BaseTable)`
  width: auto;
  min-width: 360px;
`;

export const ChartWrapper = styled.div`
  width: 100%;
`;
